import { Icon, IconProps } from './Icon';

interface RecentlyEditedIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const RecentlyEditedIcon = ({ color = '#5E6A81', gradient, ...props }: RecentlyEditedIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 28 28"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.833 11.5303V15.1668H16.4695L24.1695 7.59283C24.6315 7.13783 24.635 6.39467 24.1765 5.93617L22.0625 3.82217C21.604 3.36367 20.8597 3.36717 20.4058 3.82917L12.833 11.5303Z"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M8.16667 15.167H5.83333C4.54417 15.167 3.5 16.2112 3.5 17.5003V17.5003C3.5 18.7895 4.54417 19.8337 5.83333 19.8337H22.1667C23.4558 19.8337 24.5 20.8778 24.5 22.167V22.167C24.5 23.4562 23.4558 24.5003 22.1667 24.5003H17.5"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
